export const NO_RUT = 'undefined'

export function formatRut(rut: string, mode: 'full' | 'simple' = 'full'): string {
  if (rut.length === 0) {
    return ''
  }
  const clean = rut.replace(/-/g, '').replace(/\./g, '')
  const dv = clean.slice(-1).toUpperCase()
  const digits = clean.slice(0, -1)
  if (mode === 'simple') {
    return `${digits.trim()}-${dv}`
  }
  const grouped = digits.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  return `${grouped.trim()}-${dv}`
}

export function checkRut(rut: string): boolean {
  const simple = formatRut(rut, 'simple')
  const minified = simple.replace('-', '')
  const body = minified.slice(0, -1)
  const dvChar = minified.slice(-1).toUpperCase()
  if (body.length < 7 || !/^\d+$/.test(body)) {
    return false
  }
  let sum = 0
  let multiplier = 2
  for (let i = 1; i <= body.length; i += 1) {
    sum += multiplier * Number(body[body.length - i])
    multiplier = multiplier < 7 ? multiplier + 1 : 2
  }
  const expected = (11 - (sum % 11)) % 11
  const actual = dvChar === 'K' ? 10 : Number(dvChar)
  return expected === actual
}
